import { graphql } from 'relay-runtime';

export const getSkillAssessments = graphql`
  query MonitoringSkillAssessmentsQuery(
    $filter: StudentsSkillAssessmentsFilterInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $order: [StudentSkillAssessmentSortInput!]
    $skip: Boolean = false
  ) {
    studentsSkillAssessments(
      filter: $filter
      first: $first
      order: $order
      last: $last
      before: $before
      after: $after
    ) @skip(if: $skip) {
      nodes {
        id
        sessionNumber
        user {
          id
          firstName
          lastName
          publicUserId
          roles {
            id
            name
          }
        }
        skill {
          id
          name
          code
        }
        score
        maxScore
        sessionCompletedOn
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const getSkillsDiagnosticHistory = graphql`
  query MonitoringAllSkillsQuery(
    $filter: AllSkillsFilterInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $order: [SkillSortInput!]
    $skip: Boolean = false
  ) {
    allSkills(filter: $filter, first: $first, last: $last, before: $before, after: $after, order: $order)
      @skip(if: $skip) {
      nodes {
        id
        code
        name
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const getSkillsDiagnosticHistoryCSV = graphql`
  query MonitoringAllSkillsCSVQuery(
    $filter: AllSkillsFilterInput!
    $first: Int
    $after: String
    $order: [SkillSortInput!]
    $skip: Boolean = false
  ) {
    allSkills(filter: $filter, first: $first, after: $after, order: $order) @skip(if: $skip) {
      nodes {
        id
        code
        name
      }

      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const getSkillAssessmentSubstate = graphql`
  query MonitoringSkillSubStateReporQuery($filter: StudentsSkillSubStateReportInput!, $skip: Boolean = false) {
    studentsSkillSubStateReport(filter: $filter) @skip(if: $skip) {
      skill {
        id
      }
      usersBySkillResults {
        value {
          id
          firstName
          lastName
          publicUserId
        }
        key
      }
    }
  }
`;

export const allStandardsGrades = graphql`
  query MonitoringStandardsGradesQuery {
    standardGrades {
      name
      id
    }
  }
`;
